import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import {Route, NavLink, Redirect} from 'react-router-dom'
import Modal from './Modal'
import HistoryTab from'./HistoryTab'
import OverviewTab from'./OverviewTab'
import FeedbackTab from'./FeedbackTab'
import { updateUserRole } from '../../../../redux/actions/user_actions'
import CircularProgress from '@material-ui/core/CircularProgress';
import axios from 'axios'

class ProfilePage extends Component {
    signal = axios.CancelToken.source()
    state = {
        loading: true,
        name: null,
        userRole: null,
        icon: null,
        userList: null,
        openModal: false,
        newRole: null,
        assignments: [],
        userRoleModal: false,
    }

    componentDidMount = () => {
        this.loadData()
    }

    componentWillUnmount = () => {
        this.signal.cancel('Api is being canceled');
    }

    loadData = () => {
        let signalToken = this.signal.token
            Promise.all([
                this.props.fetchUserProfile(this.props.id, signalToken),
                // this.props.fetchAllWorkInstructions(signalToken),
            ]).then(([res1, res2]) => {
                this.setState({
                    loading: false,
                    name: this.props.user.username,
                    userRole: this.props.user.role,
                    user: this.props.user,
                    userId: this.props.user._id,
                    assignments: this.props.user.assignments
                })
            }).catch(err => {
                if (axios.isCancel(err)) {
                    console.info('User Profile Page - ', err.message)
                } else {
                    console.debug('Error', err.message)
                }
            });
    }

    confirmChanges = () => {
        let payload={
            user_id: this.state.userId,
            userRole: this.state.userRole,
        }

        this.setState({
            userRoleModal: false
        }, () => this.props.confirmChanges(payload))
    }

    modifyRole = (role) => {
        if (role !== this.state.userRole) {
            this.setState({userRole: role}, this.confirmChanges)
        } else {
            return
        }
    }

    selectNewRole = (newRole) => {
        this.setState({
            newRole: newRole
        })
    }

    closeModal = () => {
        this.setState(prevState => ({
            openModal: !prevState.openModal,
            userRoleModal: !prevState.userRoleModal
        }))
    }

    displayModal = () =>{
        if (this.state.userRoleModal) {
            return <Modal closeModal={this.closeModal} 
                        callingComponent={"management-user-permissions/role"}
                        currentRole={this.state.userRole}
                        modifyRole={this.modifyRole}
                        confirmChanges={this.confirmChanges}
                        contentHeight={"30%"}
                        containerHeight={"90%"}
                        modalTitle={"Please Select User Role"}/>
        }
    }

    processRedirect = () => {
            return <Route exact path={`${this.props.match.path}`} render={() => <Redirect to={`/dashboard/management/users/${this.props.id}/overview`} />} />
    }
        
    renderNavLinks = () => {
        return <div id="navigation-tabs">
            <NavLink activeStyle={{ backgroundColor: "#52628f", color: "white" }} className="navigation-tab" to={`/dashboard/management/users/${this.props.id}/overview`}>User Overview</NavLink>
            <NavLink activeStyle={{ backgroundColor: "#52628f", color: "white" }} className="navigation-tab" to={`/dashboard/management/users/${this.props.id}/history`}>Activity History</NavLink>
            {/* <NavLink activeStyle={{ backgroundColor: "#52628f", color: "white" }} className="navigation-tab" to={`/dashboard/management/users/${this.props.id}/feedback`}>Feedback</NavLink> */}
        </div>
    }

    render() {
        return this.state.loading ? 
        <div id="user-summary-container" className="flex-centered shadow" >
            <CircularProgress />
        </div> :
        <Fragment>
                {this.displayModal()}
                
                <div id="user-summary-container" className={`flex-column shadow ${this.state.userRoleModal ? "modal-open" : ""}`}>
                    <div id="user-summary-header" className="flex-center FontSize20">
                        <h3>{this.state.name}</h3>
                    </div>
                    {this.renderNavLinks()}
                    {this.processRedirect()}

                <Route path={`/dashboard/management/users/:userId/overview`}
                    render={(props) => <OverviewTab {...props}
                    user={this.props.user}
                    modifyRole={this.modifyRole}
                    />}
                />

                <Route path={`/dashboard/management/users/:userId/history`}
                        render={(props) => <HistoryTab {...props}
                        user={this.props.user}
                        assignments={this.props.user.assignments}
                    />} 
                />

                <Route path={`/dashboard/management/users/:userId/feedback`}
                    render={(props) => <FeedbackTab {...props}
                    username={this.props.user.username}
                    openModal={() => this.setState({userRoleModal: true})}
                    />}
                />
                </div>
    </Fragment>
    }
}

const mDTP = dispatch => {
    return {
        confirmChanges: (payload) => dispatch(updateUserRole(payload))
    }
}
export default withRouter(connect(null, mDTP)(ProfilePage));
